import { TfiMenu } from 'react-icons/tfi';
import type { headerProps } from '../../models/headerProps';
import { getItemWebStorage, setItemWebStorage } from '../../features/webStorageSaver/webStorageSaver';
import { useDispatch } from 'react-redux';
import { setSidebarIsShown } from '../../stateManagement/reducers/SidebarBlockSlice';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { isDev } from '../../features/developmentCheck/developmentCheck';
const loginLogoSrc = require('../../assets/images/logos/indorgeo-logotype.svg').default

// Компонент - шапка всего сайта
export function Header({ type }: headerProps) {
    const dispatch = useDispatch();
    const currentConfig = getItemWebStorage('currentConfig')
    const { logo, company } = currentConfig ?? {}
    const sidebarIsShown = useAppSelector(state => state.sidebar.sidebarIsShown)
    const windowInnerWidth = window.innerWidth

    // Функция, отвечающая за раскрытие sidebar при клике
    function changeClassOnClick(event: React.MouseEvent<HTMLDivElement>) {
        event.preventDefault()
        dispatch(setSidebarIsShown(!sidebarIsShown))
        const sidebarLocalSettings = getItemWebStorage('sidebar')
        const newSidebarSettings = {
            ...sidebarLocalSettings,
            isShown: !sidebarIsShown
        }
        setItemWebStorage('sidebar', newSidebarSettings)
    }

    function getLogoSrcForDev() {
        let logoPath
        let urlParsed: any
        urlParsed = logo.split('/')
        let logoName = urlParsed[urlParsed.length - 1]
        logoPath = urlParsed.includes('logos') ? `logos/${logoName}` : `${logoName}`
        try {
            return require(`../../assets/images/${logoPath}`)
        } catch {
            console.error(`Ошибка загрузки изображения ${logoPath}`)
        }
    }

    return (
        <>
            {/* базовая шапка сайта */}
            {type === "default" &&
                <div onClick={windowInnerWidth > 720 ? changeClassOnClick : () => { }} className="header-div">
                    <div className="header-side-icon-div" onClick={windowInnerWidth < 720 ? changeClassOnClick : () => { }}>
                        <TfiMenu color="white" className="header-side-icon" />
                    </div>
                    <img src={isDev() ? getLogoSrcForDev() : logo} alt={company} className="header-logo-icon" />
                </div>
            }
            {/* шапка для страницы авторизации */}
            {type === "login" &&
                <div className="header-div">
                    <a href="https://geo.indorsoft.ru">
                        <img src={loginLogoSrc} alt="Indorsoft" className="login-header-logo-icon" />
                    </a>
                </div>
            }
        </>
    );
}

